import { Button, Checkbox,  Select, Table, Tag } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { Link, useLoaderData, useNavigate, useParams } from 'react-router-dom';
import Filters from '../../../globalComponents/Filters';
import Axios from '../../utils/axios';
import Pagination from '../../../globalComponents/Pagination';

const columns = [
  {
    title: 'Reference',
    dataIndex: 'number',
    ellipsis: true,
    key: 'number',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'From',
    dataIndex: 'from',
    ellipsis: true,
    key: 'from',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'To',
    dataIndex: 'to',
    ellipsis: true,
    key: 'to',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Contact',
    dataIndex: 'contact',
    key: 'contact',
    ellipsis: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Scheduled Date',
    dataIndex: 'schedule_date',
    key: 'schedule_date',
    ellipsis: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{new Date(record.schedule_date).toUTCString()}</span>
  },
  {
    title: 'Source Document',
    dataIndex: 'source_document',
    key: 'source_document',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: '120px',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <Badge className={record.status === 'waiting' ? "text-blue-600 bg-blue-100 w-max" : record.status === 'done' ? "text-green-950 bg-green-100 w-max" : record.status === 'draft' ? "text-slate-950 bg-slate-100 w-max" : 'text-green-900 bg-green-300 w-max'}>{record.status}</Badge>
  },
  {
    title: 'Pick Later',
    dataIndex: 'pick_later',
    key: 'pick_later',
    width: '80px',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <Checkbox checked={record.pick_later} disabled/>
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/inventory/transfers/'+record.number.replaceAll('/', '-')}>
        EDIT
      </Link>
    )
  }
]

const items = [
  {key: 'my_transfers', label: 'My Transfers'},
  {type: 'divider'},
  {key: 'draft', label: 'Draft'},
  {key: 'waiting', label: 'Waiting'},
  {key: 'ready', label: 'Ready'},
  {key: 'done', label: 'Done'},
  {key: 'cancelled', label: 'Cancelled'},
  {type: 'divider'},
  {key: 'backorders', label: 'Backorders'}
];
const options = [
  {label: 'Transfer', value: 'transfer'},
  {value: 'op', label: 'Operation Type'}
];

const Transfers = () => {
  const transfers = useLoaderData();
  const navigate = useNavigate();
  const params = useParams();
  let params_ = params.seo ? JSON.parse(params?.seo) : null;

  const [search, setSearch] = useState('');
  const [searchTransfers, setSearchTransfers] = useState({transfers: transfers.transfers ? transfers.transfers : [], totalRows: transfers.totalRows});
  const [selectedFilters, setSelectedFilters] = useState(params_ !== null ? [params_.status] : []);
  const [searchBy, setSearchBy] = useState('transfer');
  const [paginations, setPaginations] = useState({pageSize: 100, page: 1});


  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/inventory/transfers/'+record.number.replaceAll('/', '-'))
    };
  }

  const handleChange = (e, option) => {
    let value_ = e.map(item => item.toLowerCase());
    setSearch(value_)
  }


  async function fetchUserList(filters, pagination_) {

    return Axios(`transfers/find/pick-laters?filter=${JSON.stringify(filters)}&&pagination=${JSON.stringify(pagination_)}`)
      .then((response) => response.data)
      .then((res) => {
        setSearchTransfers(res);
        // setPaginations({...paginations, total: res.totalRows})
      
      });
  }


  useEffect(() => {
    // const totalPages = Math.ceil(paginations.total / paginations.pageSize);
    // if (paginations.page < 1) setPaginations({...paginations, page: 1});
    // if (paginations.page > totalPages) setPaginations({...paginations, page: totalPages});
    const offset = (paginations.page - 1) * paginations.pageSize;
    let pagination_ = {offset, pageSize: paginations.pageSize};
    let filters = {search: {by: params_ !== null ? 'op' : searchBy, values: params_ !== null ? [params_.seo] : search, filters: params_ !== null ? [params_.status] : selectedFilters}};
    // fetchUserList(filters, pagination_);

  },[selectedFilters, searchBy, search, paginations])


  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Pick Later Transfers</h3>
        <div className='flex bg-white w-1/2'>
          
          <div className='flex w-full bg-white border'>
            <Select options={options} defaultValue={params_ !== null ? 'op' : searchBy} onChange={(v, opt) => setSearchBy(v)} variant='borderless' style={{width: '200px'}} />
            <Select
              mode='tags'
              size={'middle'}
              placeholder='Search'
              value={search.length > 0 ? search : params_ !== null ? [params_.seo] : null}
              onChange={handleChange} 
              className='w-full'
              variant='borderless'
              dropdownStyle={{visibility: 'hidden'}}
            />
          </div>
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/inventory/transfers/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='dark:bg-gray-900 column flex justify-between'>
            <Filters items={items} setSelectedFilters={setSelectedFilters} selectedFilters={selectedFilters}/>
            <Pagination paginations={paginations} total={searchTransfers.totalRows} setPaginations={setPaginations}/>
          </div>
        </div>
      </div>
      <Table
        rowKey={'number'}
        onRow={onRow} 
        rootClassName='hover:cursor-pointer'
        dataSource={searchTransfers.transfers}
        columns={columns}
        pagination={false}
      />
    
    </div>
  )
}

export default Transfers;